import React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const AngleUpIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 320 512", ...rest } = props;
    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <path d="M168.5 164.2l148 146.8c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L160 229.3 40.3 347.8c-4.7 4.7-12.3 4.7-17 0L3.5 328c-4.7-4.7-4.7-12.3 0-17l148-146.8c4.7-4.7 12.3-4.7 17 0z"></path>
        </SvgIcon>
    );
};
